import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';

type SummaryTabViewProps = {
  tabs: {
    label: string;
    content: React.ReactNode;
  }[];
};

export const SummaryTabView = (props: SummaryTabViewProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <Box>
      <Tabs
        onChange={(_, value: number) => setCurrentIndex(value)}
        value={currentIndex}
        indicatorColor="primary"
        textColor="primary"
      >
        {props.tabs.map(tab => (
          <Tab label={tab.label} key={tab.label} />
        ))}
      </Tabs>

      {props.tabs.map((tab, index) => (
        <Box
          key={tab.label}
          sx={{
            display: index === currentIndex ? 'inherit' : 'none',
          }}
        >
          {tab.content}
        </Box>
      ))}
    </Box>
  );
};
